import { Package, Plus } from 'lucide-react';
import PackageCard from './PackageCard';
import FeatureLocked from '../../../../../../components/gating/FeatureLocked';
import { postTripData } from '../../../../utils/postTripHelpers';

const PackagesList = ({
    packages,
    loading,
    isLocked,
    onOpenCreate,
    onView,
    onEdit,
    onDelete,
    onToggleStatus
}) => {
    const ghostPackages = postTripData.sampleGhostPackages || [];

    if (loading) {
        return (
            <div className="flex items-center justify-center py-24">
                <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-[#067978]"></div>
            </div>
        );
    }

    if (isLocked) {
        return (
            <div className="relative min-h-[480px] pb-4">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 select-none pointer-events-none opacity-75">
                    {ghostPackages.map((pkg) => (
                        <PackageCard key={pkg._id} pkg={pkg} isGhost={true} />
                    ))}
                </div>
                <FeatureLocked featureKey="packages" overlay={true} />
            </div>
        );
    }

    if (packages.length === 0) {
        return (
            <div className="relative w-full overflow-hidden pb-4">
                {/* 1. Ghost Sample Packages in background */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 select-none opacity-40 filter blur-[0.3px]">
                    {ghostPackages.map((pkg) => (
                        <PackageCard key={pkg._id} pkg={pkg} isGhost={true} />
                    ))}
                </div>

                {/* 2. Elevated Empty State Overlay Card */}
                <div className="relative z-20 -mt-60 sm:-mt-64 md:-mt-72 px-3 sm:px-6 flex justify-center items-center">
                    <div className="w-full max-w-md p-6 sm:p-8 text-center bg-white rounded-3xl border border-slate-200/90 shadow-sm relative backdrop-blur-md">
                        <div className="w-14 h-14 bg-teal-50 text-[#067978] rounded-2xl flex items-center justify-center mx-auto mb-4 border border-teal-100/80 shadow-2xs">
                            <Package size={26} />
                        </div>
                        <h3 className="text-base sm:text-lg font-bold text-slate-800 tracking-tight mb-2">
                            No Itinerary Packages Yet
                        </h3>
                        <p className="text-xs sm:text-sm text-slate-500 leading-relaxed max-w-sm mx-auto mb-6">
                            Publish custom travel itineraries & seasonal promotions to engage travellers directly in their mobile app post-trip.
                        </p>
                        <button
                            type="button"
                            onClick={onOpenCreate}
                            className="inline-flex items-center justify-center gap-2 px-6 py-2.5 bg-[#067978] hover:bg-[#056362] text-white text-xs sm:text-sm font-bold rounded-xl transition-all shadow-md shadow-[#067978]/20 cursor-pointer active:scale-95"
                        >
                            <Plus size={16} />
                            <span>Create First Package</span>
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {packages.map((pkg) => (
                <PackageCard
                    key={pkg._id}
                    pkg={pkg}
                    onView={onView}
                    onEdit={onEdit}
                    onDelete={onDelete}
                    onToggleStatus={onToggleStatus}
                />
            ))}
        </div>
    );
};

export default PackagesList;
